const seer = {
    title: "Seer: A Framework for Optimizing Traffic Camera Placement and Deep Learning Inference at the Edge for Vehicle Path Reconstruction",
    year: "2024",
    description: "Accepted at the 2024 ACM/IEEE Symposium on Edge Computing (SEC).",
    link: "https://acm-ieee-sec.org/2024",
    keywords: ["Edge Computing", "Deep Learning", "Computer Vision", "Traffic Cameras"],
  };
  
  export default seer;
  